module.exports = __webpack_public_path__ + "img/calendar-range.f2d4452c.svg";